import React from "react";

const PolicyPage = () => {
  return (
    <>
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn policy-header"
        data-wow-delay="0.1s"
      >
        <div className="container text-center py-5">
          <h4 className="display-5 text-white mb-4 animated slideInDown">
            Thông báo xử lý dữ liệu cá nhân
          </h4>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <a href="/">Trang chủ</a>
              </li>
              <li className="breadcrumb-item text-primary" aria-current="page">
                Thông báo xử lý dữ liệu cá nhân
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="styles_freeText__qCYU0 make-up-content">
              <p>
                <em>
                  Thông báo xử lý dữ liệu cá nhân (“<strong>Thông Báo</strong>”)
                  nhằm thông báo và có được sự đồng ý của Quý khách (là chủ thể
                  dữ liệu - “<strong>CTDL</strong>”) theo quy định tại Nghị định
                  số 13/2023/NĐ-CP ngày 17/4/2023 của Chính phủ về bảo vệ dữ
                  liệu cá nhân
                </em>
                <em> và các quy định pháp luật có liên quan</em>{" "}
                <em>
                  khi Công ty Tài Chính Trách Nhiệm Hữu Hạn Một Thành Viên
                  Shinhan Việt Nam, giấy chứng nhận đăng ký doanh nghiệp số
                  0304946247 (“<strong>SVFC</strong>”) tiến hành thu thập và xử
                  lý dữ liệu cá nhân. Thông Báo này là một phần của các điều
                  kiện và điều khoản điều chỉnh mối quan hệ giữa CTDL với SVFC
                  (nếu có). Bằng việc cung cấp thông tin cho SVFC, CTDL hiểu rõ
                  và đồng ý toàn bộ nội dung được quy định tại Thông Báo này.
                </em>
              </p>
              <p>
                <strong>1. Loại Dữ Liệu Cá Nhân Được Xử Lý</strong>
              </p>
              <p>
                Nhằm giúp SVFC giải đáp các thắc mắc của CTDL, cung cấp sản phẩm
                và dịch vụ cho CTDL và/hoặc cung cấp các sản phẩm và dịch vụ nói
                chung, SVFC có thể cần và/hoặc được yêu cầu xử lý các dữ liệu cá
                nhân<a href="#_ftn1">[1]</a>
                của CTDL, bao gồm nhưng không giới hạn các dữ liệu cá nhân liên
                quan trực tiếp hoặc gián tiếp đến CTDL và/hoặc các giao dịch của
                CTDL với SVFC, và những thông tin cần thiết khác liên quan đến
                CTDL và (các) giao dịch của CTDL với SVFC hoặc các giao dịch của
                bên thứ ba có liên quan đến CTDL với SVFC.
                <br />
              </p>
              <p>
                <a href="#_ftnref1">
                  <em>
                    <strong>[1]</strong>
                  </em>
                </a>{" "}
                <em>Dữ liệu cá nhân bao gồm: </em>
              </p>
              <ul>
                <li>
                  <em>
                    Dữ liệu cá nhân cơ bản theo quy định tại Điều 2.3 Nghị Định
                    số 13/2023/NĐ-CP
                  </em>
                </li>
                <li>
                  <em>
                    Dữ liệu cá nhân nhạy cảm theo quy định tại Điều 2.4 Nghị
                    Định số 13/2023/NĐ-CP
                  </em>
                </li>
                <li>
                  <em>
                    Thông tin tín dụng theo quy định tại Điều 3.1, Nghị Định số
                    58/2021/NĐ-CP.
                  </em>
                </li>
              </ul>
              <p>
                <em>
                  <strong>2. Cách Thức Thu Thập Dữ Liệu Cá Nhân</strong>
                </em>
              </p>
              <h1> </h1>
              <p>
                SVFC có thể thu thập thông tin từ CTDL và từ nhiều nguồn khác
                nhau, bao gồm nhưng không giới hạn:
              </p>
              <p>
                Từ mối quan hệ của CTDL với SVFC, chẳng hạn như thông tin mà
                CTDL cung cấp trong các đề nghị sử dụng các sản phẩm và dịch vụ
                của SVFC, khi sử dụng các sản phẩm và dịch vụ của SVFC, khi thực
                hiện các khảo sát, tham gia các chương trình ưu đãi hoặc các bài
                đánh giá năng lực tài chính;
              </p>
              <p>
                Từ việc phân tích hành vi sử dụng và quản lý (các) giao dịch,
                được thực hiện từ (các) thẻ tín dụng/(các) khoản vay của CTDL;
              </p>
              <p>
                Từ các bên thứ ba có liên quan đến CTDL, chẳng hạn như người
                tham chiếu, người sử dụng lao động, đồng sở hữu tài khoản, đơn
                vị cung cấp giải pháp bảo mật, người bảo lãnh và người bồi
                thường, bên bảo hiểm, hệ thống bán lẻ hoặc đơn vị cung cấp sản
                phẩm dịch vụ là đối tác của SVFC tùy thuộc vào sự chấp thuận
                trước của CTDL; bên thứ ba đã được CTDL kê khai, quản lý, sử
                dụng, lưu trữ những thông tin đó với thời hạn phù hợp theo quy
                định pháp luật;
              </p>
              <p>
                Thông qua lời nói, hình ảnh và phản hồi bằng văn bản của CTDL
                với SVFC và/hoặc các bên được ủy quyền của SVFC qua tin nhắn,
                điện thoại hoặc thiết bị di động, email, fax, thư, trình duyệt
                tin điện tử, các trang mạng xã hội hoặc bất kỳ kênh thông tin
                nào khác;
              </p>
              <p>
                Từ các bản ghi của camera quan sát (CCTV) được lắp đặt tại địa
                điểm kinh doanh của SVFC; và tại các địa điểm mà CTDL thực hiện
                các giao dịch có liên quan đến SVFC (ví dụ như máy hình ảnh thu
                thập được từ camera tại máy ATM của các ngân hàng);{" "}
              </p>
              <p>
                Từ các cơ quan có thẩm quyền để xác định rõ tình hình tài chính
                hiện tại và trong quá khứ của CTDL, cơ quan có thẩm quyền/được
                phép cung cấp báo cáo tín dụng;
              </p>
              <p>
                Từ các nguồn khác, ví dụ như các tổ chức tài chính, các bên tư
                vấn về khảo sát, truyền thông mạng xã hội, tiếp thị, tham chiếu
                tín dụng, ngăn ngừa gian lận, các bên đối tác liên kết cho các
                chương trình ưu đãi và khuyến mãi của SVFC;
              </p>
              <p>
                Từ các nguồn khác theo sự đồng ý của CTDL đối với việc cung cấp
                thông tin liên quan đến CTDL và/hoặc các nguồn mở, không bị hạn
                chế;
              </p>
              <p>
                Thông qua các tập tin được tạo bởi trang mạng mà CTDL truy cập
                (cookie) hoặc các công cụ tương tự;
              </p>
              <p>
                Từ bất kỳ thông tin nào được cung cấp và/hoặc thu thập khi CTDL
                truy cập các trang tin điện tử của SVFC và/hoặc tải xuống ứng
                dụng của SVFC dành cho thiết bị di động.
              </p>
              <p>
                <strong>3. Mục Đích Xử Lý Xử Lý Dữ Liệu Cá Nhân</strong>
              </p>
              <p>
                SVFC có thể xử lý dữ liệu cá nhân của CTDL cho những mục đích (“
                <strong>
                  <em>Mục Đích</em>
                </strong>
                ”) sau:
              </p>
              <p>
                Xem xét/thẩm định các đề nghị của CTDL liên quan đến việc sử
                dụng các sản phẩm/dịch vụ của SVFC, xác minh tình hình tài chính
                của CTDL, tiến hành kiểm tra lịch sử tín dụng và thu thập hoặc
                cung cấp dẫn chiếu tín dụng;
              </p>
              <p>
                Xác minh các giao dịch của CTDL có liên quan đến sản phẩm và
                dịch vụ của SVFC để bảo đảm tính chính xác của giao dịch;
              </p>
              <p>Quản lý và duy trì (các) khoản vay, thẻ tín dụng của CTDL;</p>
              <p>
                Quản lý các ưu đãi, cuộc thi, chương trình khuyến mại, chương
                trình chăm sóc khách hàng và/hoặc nâng cao trải nghiệm của CTDL
                khi sử dụng các dịch vụ/sản phẩm của SVFC;
              </p>
              <p>
                Hiểu rõ hơn về nhu cầu đầu tư trong hiện tại, tương lai và tình
                hình tài chính của CTDL;
              </p>
              <p>
                Tiếp thị và cung cấp cho CTDL thông tin của SVFC hoặc các bên
                thứ ba về sản phẩm, dịch vụ, ưu đãi và/hoặc các cuộc thi mà CTDL
                có thể quan tâm (SVFC có thể được hoặc không được trả thù lao),
                bao gồm nhưng không giới hạn quản lý sản phẩm và dịch vụ được
                cung cấp bởi các đối tác đồng thương hiệu của SVFC hay cung cấp
                bảo hiểm;
              </p>
              <p>
                Cải tiến các sản phẩm/dịch vụ của SVFC cũng như thử nghiệm,
                nghiên cứu, phân tích, phát triển sản phẩm và tính năng mới của
                sản phẩm và/hoặc dịch vụ của SVFC;
              </p>
              <p>
                Nghiên cứu cách CTDL sử dụng sản phẩm/dịch vụ nhằm mục đích
                quảng cáo sản phẩm/dịch vụ của SVFC;
              </p>
              <p>
                Thông báo cho CTDL các thông tin về quyền lợi và thay đổi các
                tính năng của sản phẩm/dịch vụ của SVFC;
              </p>
              <p>
                Cung cấp cho CTDL các sản phẩm và dịch vụ cung cấp hoặc quản trị
                bởi nhà cung cấp dịch vụ, nhà thầu (bao gồm cả nhà thầu phụ),
                bên bán hàng, đối tác kinh doanh của SVFC;
              </p>
              <p>
                Phản hồi các thắc mắc, khiếu nại của CTDL và giải quyết các
                tranh chấp nói chung;
              </p>
              <p>
                Thực hiện nghiên cứu cho các mục đích phân tích bao gồm nhưng
                không giới hạn ở việc khai thác dữ liệu và phân tích các giao
                dịch của CTDL với SVFC;
              </p>
              <p>
                Để tạo và duy trì các mô hình liên quan đến tín dụng, hành vi và
                rủi ro để chấm điểm tín dụng tự động hoặc tính phù hợp và/hoặc
                bất kỳ mục đích nào liên quan đến các mục đích hoặc chức năng
                kiểm toán, tuân thủ và quản lý rủi ro;
              </p>
              <p>
                Phân tích điểm tín dụng, đánh giá và giám sát năng lực trả nợ
                của CTDL như là một phần của quy trình cho vay và quản lý khoản
                vay;
              </p>
              <p>
                Chuyển giao hoặc chuyển nhượng các quyền, lợi ích và nghĩa vụ
                theo các thỏa thuận CTDL đã ký với SVFC;
              </p>
              <p>
                Bảo vệ hoặc thực thi bất kỳ quyền nào của SVFC, bao gồm nhưng
                không giới hạn quyền của SVFC để xử lý, thu hồi khoản nợ;
              </p>
              <p>
                Tiến hành kiểm tra phòng chống rửa tiền; phát hiện, điều tra,
                ngăn chặn và truy tố tội phạm;
              </p>
              <p>
                Tuân thủ các quy định và yêu cầu thi hành pháp luật; đảm bảo
                việc SVFC tiết lộ thông tin theo yêu cầu của pháp luật áp dụng;
                các mục đích khác theo yêu cầu hoặc được cho phép với pháp luật,
                quy định, hướng dẫn hoặc quyết định của tòa án và/hoặc các cơ
                quan có thẩm quyền.
              </p>
              <p>
                Cung cấp cho Công ty Thông tin tín dụng nhằm tạo lập các sản
                phẩm Thông tin tín dụng để cung cấp dịch vụ cho SVFC.
              </p>
              <p>
                SVFC đảm bảo sẽ thông báo và có sự chấp thuận của CTDL trước khi
                xử lý dữ liệu cá nhân của CTDL cho mục đích khác với Mục Đích
                nêu trên.
              </p>
              <p>
                <strong>4. Chuyển Giao Dữ Liệu Cá Nhân Của CTDL</strong>
              </p>
              <p>
                Là một phần của việc cung cấp sản phẩm và dịch vụ cho CTDL
                và/hoặc để thực hiện một hoặc bất kỳ mục đích nào được nêu trong
                Thông Báo này, CTDL đồng ý và cho phép SVFC chuyển giao dữ liệu
                cá nhân của CTDL và dữ liệu cá nhân của bên thứ ba có liên quan
                đến CTDL cho các bên thứ ba ở bên trong hoặc ngoài lãnh thổ Việt
                Nam, cụ thể như dưới đây:
              </p>
              <p>
                Các công ty thành viên thuộc tập Tập đoàn Tài chính Shinhan
                (Shinhan Financial Group);
              </p>
              <p>
                Các bên liên kết, các công ty đối tác, các bên cung cấp dịch vụ
                xác thực thông tin, tổng hợp và phân tích dữ liệu đang hoạt động
                hợp pháp và các cơ quan có thẩm quyền nhằm mục đích: (i) xác
                minh/đối chiếu dữ liệu cá nhân, đánh giá năng lực tài chính/khả
                năng chi trả, thẩm định hồ sơ tín dụng và các yêu cầu quản lý
                khoản vay sau khi giải ngân, phù hợp với quy định nội bộ về bảo
                mật thông tin của SVFC tùy từng thời điểm; (ii) báo cáo tín dụng
                và cung cấp thông tin tín dụng theo yêu cầu của cơ quan có thẩm
                quyền, theo quy định của pháp luật trong từng thời điểm.
              </p>
              <p>
                Các tổ chức hỗ trợ SVFC xử lý hoặc thực hiện các giao dịch mà
                CTDL yêu cầu, bao gồm nhưng không giới hạn các bên cung cấp dịch
                vụ hành chính, tiếp thị, in ấn, giao nhận và vận chuyển các tài
                liệu đến CTDL, quy trình kinh doanh, du lịch, thị thực, quản trị
                tri thức, quản trị nhân sự, xử lý dữ liệu, công nghệ thông tin,
                máy tính, thanh toán, thu hồi nợ, nghiên cứu trị trường, đổi
                thưởng, lưu trữ và quản lý hồ sơ, nhập liệu, pháp lý, trang mạng
                hoặc phương tiện truyền thông xã hội, viễn thông, gửi tin nhắn
                hoặc gửi thư điện tử, kết nối mạng, điện thoại, cơ sở hạ tầng và
                hỗ trợ công nghệ, báo cáo rủi ro, quyết định tín dụng, an toàn
                thông tin, duy trì phần mềm và giấy phép, các dịch vụ tư vấn,
                và/hoặc các dịch vụ khác.
              </p>
              <p>
                Các tổ chức cung cấp dịch vụ cho SVFC trong quá trình cung cấp
                hoặc truyền đạt thông tin về các sản phẩm/dịch vụ của SVFC cho
                CTDL;
              </p>
              <p>
                Trung tâm Thông tin Tín dụng Quốc gia Việt Nam, các công ty
                thông tin tín dụng<a href="#_ftn1">[2]</a> và bất kỳ tổ chức nào
                được thành lập bởi Ngân hàng nhà nước Việt Nam hoặc bất kỳ tổ
                chức khác có thẩm quyền đối với SVFC;{" "}
              </p>
              <p>
                Bất kỳ bên nào có nghĩa vụ bảo mật đối với SVFC đã cam kết bảo
                mật thông tin;
              </p>
              <p>
                Cá nhân, tổ chức (bao gồm nhưng không giới hạn đối với kế toán
                viên, kiểm toán viên, luật sư, cố vấn tài chính hoặc các cố vấn
                chuyên nghiệp khác) được CTDL ủy quyền;
              </p>
              <p>
                Các bên thứ ba thông qua việc bán nợ, hoặc mua bán sáp nhập
                doanh nghiệp bởi bất kỳ công ty nào của Shinhan Financial Group,
                với điều kiện là bên nhận dữ liệu cũng xử lý dữ liệu cá nhân của
                CTDL cho cùng mục đích ban đầu khi CTDL cung cấp dữ liệu cá nhân
                cho SVFC hoặc được SVFC xử lý;
              </p>
              <p>
                Bất kỳ đơn vị cung cấp giải pháp bảo mật mà SVFC dùng để cung
                cấp dịch vụ, tiện ích cho CTDL;
              </p>
              <p>
                Bất kỳ người nào có ý định quyết toán khoản dư nợ của các khoản
                vay/thẻ tín dụng được SVFC cấp cho CTDL;
              </p>
              <p>
                Bất kỳ tổ chức xếp hạng tín dụng, công ty bảo hiểm hoặc môi giới
                bảo hiểm;
              </p>
              <p>
                Bất kỳ tổ chức tài chính, đơn vị bán hàng, các tổ chức thẻ khác
                liên quan đến thẻ tín dụng do SVFC phát hành cho CTDL, tổ chức
                từ thiện hoặc tổ chức phi lợi nhuận.
              </p>
              <p>
                Bất kỳ cơ quan có thẩm quyền yêu cầu cung cấp thông tin theo quy
                định pháp luật.
              </p>
              <p>
                <br />
              </p>
              <p>
                <a href="#_ftnref1">[2]</a> Thông tin của Công ty Thông tin tín
                dụng mà SVFC đang là tổ chức tham gia như sau:
              </p>
              <ul>
                <li>
                  Tên công ty: CÔNG TY CỔ PHẦN THÔNG TIN TÍN DỤNG VIỆT NAM (PCB)
                </li>
                <li>Giấy chứng nhận đăng ký doanh nghiệp: số 0102547296 </li>
                <li>Đăng ký lần đầu: ngày 27/11/2007</li>
              </ul>
              <p>
                Không mâu thuẫn với các nội dung khác tại Thông Báo này, trong
                trường hợp PCB bị thu hồi Giấy chứng nhận đủ điều kiện hoạt động
                cung ứng dịch vụ thông tin tín dụng, SVFC sẽ ngừng cung cấp dữ
                liệu cá nhân của CTDL cho PCB và CTDL đồng ý dữ liệu cá nhân của
                CTDL tại PCB được xử lý theo quy định của Chính phủ về hoạt động
                cung ứng dịch vụ thông tin tín dụng. SVFC sẽ thông báo với CTDL
                về việc xử lý dữ liệu cá nhân của Khách hàng vay trong thời hạn
                tối đa 10 (mười) ngày làm việc, kể từ ngày SVFC nhận được thông
                báo của PCB về phương án xử lý dữ liệu cá nhân của CTDL tại PCB.
                CTDL khẳng định rằng mình hiểu và biết rõ rằng dữ liệu cá nhân
                được thu thập, xử lý, và lưu trữ trong thời gian tối thiểu 05
                (năm) năm nhằm mục đích tạo lập các sản phẩm thông tin tín dụng
                bởi các phần mềm chuyên dụng của PCB.{" "}
              </p>
              <p>
                <strong>5. Tiếp Thị</strong>
              </p>
              <p>
                SVFC có thể chia sẻ dữ liệu cá nhân của CTDL cho các bên thứ ba
                nhằm thực hiện các hoạt động quảng cáo có định hướng.{" "}
              </p>
              <p>
                CTDL hiểu rõ và đồng ý về việc SVFC và Shinhan Financial Group,
                các đơn vị liên kết, đối tác, bên cung cấp dịch vụ của SVFC được
                xử lý những dữ liệu cá nhân của CTDL cho mục đích quảng cáo,
                tiếp thị, nghiên cứu thị trường và khuyến mại phù hợp theo quy
                định của pháp luật.
              </p>
              <p>
                Bất cứ lúc nào CTDL cũng có thể thông báo cho SVFC về việc không
                muốn nhận thông tin truyền thông tiếp thị trực tiếp từ SVFC, từ
                các tổ chức cá nhân trong SVFC và Shinhan Financial Group
                và/hoặc từ đơn vị bán hàng và đối tác chiến lược của SVFC bằng
                cách thông báo cho SVFC theo thông tin liên hệ được cung cấp ở
                Điều 11 của Thông Báo này. Trong một số trường hợp nhất định,
                khi thông tin tiếp thị từ SVFC được gửi qua trình duyệt đến
                thiết bị di động của CTDL, CTDL sẽ phải thực hiện theo các bước
                nhất định để ngừng nhận thông tin tiếp thị.
              </p>
              <p>
                <strong>
                  6. Thời Gian Lưu Trữ Và Xử Lý Dữ Liệu Cá Nhân Của CTDL
                </strong>
              </p>
              <p>
                Trước, trong và sau thời gian CTDL sử dụng dịch vụ và sản phẩm
                của SVFC, dữ liệu cá nhân của CTDL sẽ được lưu trữ và xử lý phù
                hợp với Thông Báo này; và/hoặc các điều khoản và điều kiện của
                các thỏa thuận khác của CTDL với SVFC; hoặc khi cần thiết để
                thực hiện các nghĩa vụ của SVFC đối với CTDL; hoặc thực thi để
                bảo vệ lợi ích của Shinhan Financial Group và SVFC và/hoặc các
                khách hàng khi thấy cần thiết; hoặc theo yêu cầu của pháp luật
                hiện hành và các chính sách của SVFC liên quan đến việc lưu trữ
                và xử lý dữ liệu.
              </p>
              <p>
                <strong>
                  7. Hậu quả, thiệt hại không mong muốn có khả năng xảy ra
                </strong>
              </p>
              <p>
                Khi được chỉ định (ví dụ: trong Phiếu đề nghị cấp khoản vay/phát
                hành thẻ tín dụng) và đồng ý cho phép xử lý dữ liệu cá nhân,
                CTDL có nghĩa vụ cung cấp dữ liệu các nhân cho SVFC một cách đầy
                đủ, trung thực và chính xác để SVFC xử lý đề nghị của CTDL liên
                quan đến các sản phẩm/dịch vụ của SVFC.{" "}
              </p>
              <p>
                Nếu CTDL từ chối cung cấp dữ liệu cá nhân bắt buộc đó, hoặc
                không cung cấp chính xác hoặc không cung cấp đầy đủ dữ liệu cá
                nhân hoặc rút lại sự đồng ý cho việc xử lý dữ liệu cá nhân, thì
                các đề nghị của CTDL sẽ không được thực hiện đầy đủ, do đó, SVFC
                có thể không thể xử lý đề nghị của CTDL hoặc cung cấp cho CTDL
                các sản phẩm hoặc dịch vụ của SVFC. CTDL phải cập nhật cho SVFC
                về bất kỳ thay đổi nào đối với dữ liệu cá nhân của CTDL đã được
                SVFC ghi nhận.
              </p>
              <p>
                Việc xử lý dữ liệu cá nhân bởi SVFC và/ hoặc bên thứ ba có thể
                dẫn đến sự cố về dữ liệu cá nhân, gây ảnh hưởng tới CTDL. SVFC
                sẽ thực hiện đầy đủ các biện pháp cần thiết để đảm bảo việc bảo
                vệ và xử lý dữ liệu cá nhân theo quy định của pháp luật.
              </p>
              <p>
                <strong>
                  8. Quyền Truy Cập và Chỉnh Sửa Dữ Liệu Cá Nhân Của CTDL
                </strong>
              </p>
              <p>
                CTDL được truy cập/truy vấn để xem, chỉnh sửa dữ liệu cá nhân
                của mình sau khi đã được SVFC thu thập theo sự đồng ý, trừ
                trường hợp luật có quy định khác;
              </p>
              <p>
                Trường hợp CTDL không thể chỉnh sửa trực tiếp vì lý do kỹ thuật
                hoặc vì lý do khác, CTDL có thể yêu cầu SVFC chỉnh sửa dữ liệu
                cá nhân của mình;
              </p>
              <p>
                SVFC sẽ nỗ lực để đảm bảo quyền yêu cầu truy cập/truy vấn hoặc
                chỉnh sửa dữ liệu cá nhân của CTDL được xử lý sau khi kiểm tra
                yêu cầu và dữ liệu cá nhân hiện hữu;
              </p>
              <p>
                SVFC có thể phải giữ lại quyền truy cập/truy vấn vào dữ liệu cá
                nhân của CTDL trong một số tình huống nhất định, trong các
                trường hợp này, SVFC sẽ thông báo cho CTDL lý do không thể thực
                hiện yêu cầu của CTDL;
              </p>
              <p>
                SVFC có quyền quyết định việc cho phép hoặc không cho phép các
                yêu cầu chỉnh sửa và/hoặc có thể yêu cầu thêm tài liệu về dữ
                liệu cá nhân mới để tránh hành vi gian lận và cung cấp dữ liệu
                cá nhân không chính xác.
              </p>
              <p>
                <strong>9. Quyền Và Nghĩa Vụ Của CTDL</strong>
              </p>
              <p>
                CTDL có các quyền và nghĩa vụ theo các quy định pháp luật có
                liên quan. Nếu CTDL chưa hiểu rõ về quyền và nghĩa vụ của mình,
                CTDL vui lòng liên hệ với SVFC theo thông tin liên hệ được cung
                cấp tại Điều 11 của Thông Báo này để hiểu rõ. CTDL thừa nhận
                rằng CTDL đã đọc, hiểu rõ và đồng ý các nội dung về quyền và
                nghĩa vụ của CTDL theo quy định pháp luật hiện hành.
              </p>
              <p>
                <strong>10. Sửa Đổi Thông Báo</strong>
              </p>
              <p>
                SVFC có thể sửa đổi, cập nhật hoặc điều chỉnh Thông Báo này tùy
                từng thời điểm. Thông báo về bất kỳ sự sửa đổi, cập nhật hoặc
                điều chỉnh nào về Thông Báo này sẽ được cập nhật, đăng tải trên
                các phương tiện thông tin liên lạc mà SVFC cho là phù hợp.
              </p>
              <p>
                <strong>11. Thông Tin Liên hệ</strong>
              </p>
              <p>
                Nếu CTDL có bất kỳ thắc mắc nào liên quan đến Thông Báo này, vui
                lòng liên hệ đến SVFC theo thông tin:
              </p>
              <p>
                <strong>Điện thoại</strong>: 1900 5454 49 <strong>Email</strong>
                : dvkh@shinhanfinance.com.vn
              </p>

              <p>
                <em>
                  <em>
                    Để tránh nhầm lẫn, trong trường hợp CTDL cung cấp dữ liệu cá
                    nhân của một bên thứ ba (ví dụ như thông tin của người phụ
                    thuộc, vợ/chồng, con cái và/hoặc cha mẹ, bạn bè, bên thụ
                    hưởng, người được ủy quyền, đối tác, người liên hệ trong
                    trường hợp khẩn cấp) cho SVFC, CTDL cam kết và bảo đảm rằng
                    CTDL đã có được sự đồng ý của bên thứ ba đó cho các nội dung
                    liên quan đến việc xử lý dữ liệu được nêu tại Thông Báo này
                    (bao gồm nhưng không giới hạn việc thu thập, sử dụng và cung
                    cấp thông tin cho các Mục Đích).
                  </em>
                </em>
              </p>
              <p>
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PolicyPage;
